import styled from "styled-components";

const BaseHeadins = styled.div`
    font-family: "Open Sans";
    font-style: normal;
    display: inline;
    color #282828;
    font-weight: 800;
`;

export const Headline1 = styled(BaseHeadins)`
    font-size: 80px;
    line-height: 100px;
`;


export const Headline2 = styled(BaseHeadins)`
    font-size: 60px;
`;


export const TwoColumnBox = styled.div`
    display: flex;
    flex-direction: row;
    box-sizing: border-box;         /* Opera/IE 8+ */
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
`;

export const LargeFontParagraph = styled.p`
    color: #282828;
    font-family: "Open Sans";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px; /* 166.667% */
`;

export const BigRoundedButton = styled.button`
    align-self: flex-start;
    color: #FFF;
    text-align: center;
    font-family: "Open Sans";
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 133.333% */
    border: none;
    border-radius: 40px;
    background-color: #0073E6;
    padding: 23px 36px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    margin-bottom: 8px;
    cursor: pointer;
    :disabled {
        opacity: 0.5;
        pointer-events: none;
    }
    z-index: 1000;

`;

export const Break = styled.div`
    flex-basis: 100%;
    height: 0;
`;

export const InlineBlue = styled.span`
    color: #0073E6;
`;

export const Overline2 = styled(InlineBlue)`
    font-family: "Open Sans";
    font-style: normal;
    line-height: normal;
    font-size: 30px;
    font-weight: 700;
`;

export const Overline3 = styled(InlineBlue)`
    font-family: "Open Sans";
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const Headline3 = styled(BaseHeadins)`
    font-size: 40px;
    font-weight: 800;
    line-height: 50px;
`;

export const Headline5 = styled(BaseHeadins)`
    font-size: 18px;
    font-weight: 400;
    line-height: 30px; /* 166.667% */
`;

export const Headline4 = styled(BaseHeadins)`
    text-align: center;
    /* Headline 4 */
    font-family: "Open Sans";
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const Next = styled(BigRoundedButton)`
    margin-top: 11px;
    margin-bottom: 7px;
    margin-left: 5px;
`;

export const Back = styled(BigRoundedButton)`
    margin-top: 11px;
    margin-bottom: 7px;
    margin-left: 5px;
    background-color: #FFF;
    border: 1px solid #D4D2E3;
    color: rgba(40, 40, 40, 0.85);
`;

export const ButtonContainer = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 22px;
    align-self: stretch;
    flex-direction: row;
    margin-bottom: 0px;
    margin-top: auto;
    @media (min-width: 319px) and (max-width: 767px)  {
        flex-wrap: wrap;
        border-top: 1px solid rgba(40,40,40, 0.1);
        gap: 0;
        align-self: unset;
        margin-top: 20px;
        padding-top: 20px;
         ${Back} {
            flex: 1;
            order: 2;
            flex-basis: 100%;
        }
        ${Next} {
            flex: 1;
            order: 1;
            flex-basis: 100%;
            margin-top: 0;
        }
    }
`;

export const Input = styled.input`
    padding: 24px;
    border-radius: 50px;
    background: rgba(40, 40, 40, 0.05);
    border: none;
    color: rgba(40, 40, 40);
    /* Body 2 */
    font-family: "Open Sans";
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 100% */
    ::placeholder {
        color: rgba(40, 40, 40, 0.65);
    }
`;